"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var access = {
  brand: {
    codename: "access",
    name: "Utils",
    theme: "#000",
    logoProps: {
      name: "tools"
    }
  },
  subscriptions: {
    headerIcon: "user"
  },
  devClient: {
    headerIcon: "accountGraphInverted"
  },
  solrQuery: {
    headerIcon: "serverClient"
  },
  storybook: {
    headerIcon: "storybook"
  },
  fileuploaddebug: {
    headerIcon: "serverClient"
  },
  routes: {
    subscriptions: {
      url: "/subscriptions",
      title: "Subscriptions",
      requiredPermissions: ["view_all_subscription"]
    },
    devClient: {
      hostname: "client-ui",
      url: "/",
      title: "Dev Client",
      requiredPermissions: ["view_client_data"]
    },
    solrQuery: {
      url: "/solrQuery",
      title: "Solr Query",
      requiredPermissions: ["view_solr_cluster"]
    },
    storybook: {
      hostname: "facebook",
      url: "/static/storybook",
      title: "Storybook",
      requiredPermissions: ["view_storybook"]
    },
    fileuploaddebug: {
      url: "/fileuploaddebug",
      title: "File Upload Debugger",
      requiredPermissions: ["view_file_upload_utility"]
    }
  }
};
var _default = exports["default"] = access;